import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import {
  MessageRightWrapper,
  Avatar,
  Message,
  Label,
  AttachmentWrapper,
  AttachmentIcon,
  AttachmentName,
} from "./styles/message-right-styles";

const MessageRight = (props) => {
  const {
    avatar,
    time,
    textContent,
    action,
    actionAt,
    author,
    attachmentLink,
    attachmentName,
    jobCurrencySymbol,
    finalSalary,
  } = props;
  const label = action.replace(/_/g, " ");
  const fullName = `${author.first_name} ${author.last_name}`;
  const labelString = actionAt ? `${label}: ${actionAt}` : `${label}`;

  return (
    <MessageRightWrapper>
      <Message data-tip={time} data-for="time-right">
        <Label
          action={action}
          type={textContent !== "" ? "containsText" : null}
        >
          {finalSalary && action === "accepted_job"
            ? `${labelString}: ${jobCurrencySymbol}${finalSalary}`
            : labelString}
        </Label>
        {textContent}
        {attachmentLink && (
          <AttachmentWrapper
            href={attachmentLink}
            target="_blank"
            title="Attachment"
            type={
              textContent !== "" || action !== "send_message"
                ? "containsText"
                : null
            }
          >
            <AttachmentIcon>
              <FontAwesomeIcon icon={faFileAlt} />
            </AttachmentIcon>
            <AttachmentName>{attachmentName}</AttachmentName>
          </AttachmentWrapper>
        )}
        <ReactTooltip
          place="top"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="time-right"
        />
      </Message>
      <Avatar
        src={avatar}
        data-tip={fullName}
        data-for="author-tooltip-right"
        alt="Avatar"
      />
      <ReactTooltip
        place="left"
        type="dark"
        effect="solid"
        aria-haspopup="true"
        id="author-tooltip-right"
      />
    </MessageRightWrapper>
  );
};

MessageRight.propTypes = {
  avatar: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  textContent: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  actionAt: PropTypes.instanceOf(Date),
  author: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  attachmentLink: PropTypes.string,
  attachmentName: PropTypes.string,
  jobCurrencySymbol: PropTypes.string.isRequired,
  finalSalary: PropTypes.number,
};

MessageRight.defaultProps = {
  attachmentLink: null,
  attachmentName: null,
  actionAt: null,
  finalSalary: null,
};

export default MessageRight;
